import { GROUP_HEADER_HEIGHT } from "../../settings.ts";
import type { TrackGroups, Tracks } from "../../types.ts";

export function getTrackOffsetY(trackGroups: TrackGroups, tracks: Tracks, trackId: string): number {
  let currentY = 0;

  if (!tracks.has(trackId)) {
    return 0;
  }

  for (const trackGroup of trackGroups.values()) {
    if (!trackGroup.graphics.isVisible) {
      continue;
    }
    const currentTracks = trackGroup.trackIds.filter((id) => tracks.has(id)).map((id) => tracks.get(id)!);

    currentY += GROUP_HEADER_HEIGHT;

    for (const track of currentTracks) {
      if (track.trackId === trackId) {
        return currentY;
      }
      if (track.isVisible) {
        currentY += track.height;
      }
    }
  }

  return currentY;
}
